AlertFactory.$inject = ['$rootScope', '$q', '$timeout', '_'];

/* @ngInject */
function AlertFactory($rootScope, $q, $timeout, _) {
    var modal = {
        $el: null,
        $els: {},
        template:
            '<div id="alert_modal" class="modal fade" role="dialog">' +
            '  <div class="modal-dialog" role="document">' +
            '    <div class="modal-content">' +
            '      <div class="modal-header">' +
            '        <button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button>' +
            '        <h4 class="modal-title"></h4>' +
            '      </div>' +
            '      <div class="modal-body"><p></p></div>' +
            '      <div class="modal-code form-group-lg">' +
            '         <input pattern="[0-9]+" inputmode="numeric" type="text" value="" class="code form-control" maxlength="4" autocomplete="off" style="font-family: text-security-disc !important; -webkit-text-security: disc; text-align: center;">' +
            '      </div>' +
            '      <div class="modal-footer"></div>' +
            '    </div>' +
            '  </div>' +
            '</div>',

        _def_options: {
            backdrop: true,
            keyboard: true,
        },


        init: function () {
            var self = this;

            this.$el = $(this.template);
            $('body').append(this.$el);

            // Set $els
            this.$els = {
                title: this.$el.find('.modal-title'),
                body: this.$el.find('.modal-body p'),
                footer: this.$el.find('.modal-footer'),
                code: this.$el.find('.modal-code'),
            };

            // Events
            this.$el.find('.close').on('click', this.close.bind(this));

            this.$el.find('.modal-footer').on('click', 'button', function (e) {
                e.preventDefault();

                modal.triggerButton($(this));
            });

            this.$els.code.find('input.code').keyup(function (e) {
                if (e.keyCode === 13 && this.value.length === 4) {
                    e.preventDefault();
                    modal.ok();
                    return false;
                }
            });

            this.$els.code.find('input.code').on('keypress', function (e) {
                // Solo permitir números y teclas de control
                if (!/[0-9]/.test(e.key)) {
                    e.preventDefault();
                }
            });

 
            this.$el
                .on('hidden.bs.modal', this.clear.bind(this))
                .on('shown.bs.modal', function () {
                    if (instance.type === 'code') {
                        return self.$els.code
                            .find('input.code')
                            .val('')
                            .focus();
                    }
                    self.$els.footer.find('btn-primary').focus();
                });
        },

        triggerButton: function ($el) {
            var role = $el.attr('role');
            if (role === 'ok') {
                modal.ok();
            } else {
                modal.close();
            }
        },

        show: function (options) {
            this.$el.modal('show', _.extend({}, this._def_options, options));
        },

        open: function (options) {
            var self = this;
            options = _.extend({}, defaults, options);

            instance.defer = $q.defer();
            instance.type = options.type;

            this.$els.title.html(options.title);
            this.$els.body.html(options.text);
            this.$els.footer.empty();
            _.each(options.buttons, function (attrs, role) {
                var $btn = $(
                    '<button type="button" role="' +
                        role +
                        '" class="btn ' +
                        attrs.class +
                        '">' +
                        attrs.html +
                        '</button>',
                );
                self.$els.footer.append($btn);
            });

            if (instance.type === 'code') {
                this.$els.code.show();
            } else {
                this.$els.code.hide();
            }

            this.styleText(options.type);
            this.show();

            if (options.timeout) {
                instance.timeout_instance = $timeout(
                    modal.close.bind(modal),
                    options.timeout * 1000,
                );
            }

            return instance.defer.promise;
        },

        styleText: function (type) {
            var style = '';
            switch (type) {
                case 'success':
                    style = 'text-success';
                    break;
                case 'error':
                    style = 'text-danger';
                    break;
                case 'code':
                case 'confirm':
                    style = 'text-info';
                    break;
                default:
                    style = '';
            }
            this.$els.body.attr('class', style);
        },

        close: function () {
            switch (instance.type) {
                case 'code':
                case 'confirm':
                    instance.defer.reject();
                    break;
                case 'success':
                case 'error':
                    instance.defer.resolve();
                    break;
            }
            this.$el.modal('hide');
        },

        ok: function () {
            if (instance.type === 'code') {
                var value = this.$el.find('.modal-code input.code').val();
                instance.defer.resolve(value);
            } else if (instance.type === 'confirm') {
                instance.defer.resolve();
            } else {
                instance.defer.resolve();
            }
            this.$el.modal('hide');
        },

        clear: function () {
            instance.type = '';
            instance.defer = null;

            this.$el.removeClass('invalid');
            this.$els.body.empty();
            this.$els.footer.empty();
            this.$el.find('.modal-code input.code').val('');
            if (instance.timeout_instance) {
                $timeout.cancel(instance.timeout_instance);
                instance.timeout_instance = null;
            }
        },
    };

    modal.init();

    var defaults = {
        title: 'Alerta',
        text: '',
        class: '',
        type: 'success',
        buttons: {
            ok: {
                html: 'OK',
                class: 'btn-primary btn-lg',
            },
        },
        timeout: null,
        timeout_instance: null,
    };
    var instance = {
        type: '',
        defer: null,
    };

    class InvalidTfaCode extends Error {
        constructor() {
            super(
                'El código de 4 digitos es incorrecto. Por favor verifiquelo',
            );
        }
    }

    /**
     * ErrorHandler
     * @class ErrorHandler
     * @param  {XHR Response} response
     */
    var ErrorHandler = function (response) {
        if (response instanceof InvalidTfaCode) {
            const err = response;
            alerts.error(ErrorHandler.error_names[err.name], err.message);
            return err;
        }
        var err = response.data.error;

        alerts.error(ErrorHandler.error_names[err.name], err.message);
        return err;
    };

    /**
     * Formats the name of the error
     * @method errorName
     * @param  {String} name
     * @return {String}
     */
    ErrorHandler.errorName = function (name) {
        var names = ErrorHandler.error_names;
        if (names.hasOwnProperty(name)) {
            return names[name];
        }
        return names.default;
    };
    /**
     * List of error names
     * @property {Object} error_names
     */
    ErrorHandler.error_names = {
        InvalidFields: 'Datos Inválidos',
        default: '¡Error!',
    };

    /**
     * Alerts Public Methods
     * @type {Object}
     */
    var alerts = {
        /**
         * Sucess alert
         * @method success
         * @param  {String} title
         * @param  {String} message
         * @param  {Object} options
         * @return {Modal}
         */
        success: function (title, message, _options) {
            var options = _options || {};
            return modal.open({
                title: title,
                text: message,
                type: 'success',
                timeout: options.timeout || 1,
            });
        },
        /**
         * Error alert
         * @method error
         * @param  {String} title
         * @param  {String | Array} messages
         * @param  {Object} options
         * @return {Modal}
         */
        error: function (title, messages, options) {
            if (!_.isArray(messages)) {
                messages = [messages];
            }

            return modal.open(
                _.extend(
                    {
                        title: title,
                        text: messages.join('<br>'),
                        type: 'error',
                    },
                    options || {},
                ),
            );
        },
        /**
         * Prompts the User code
         * @method code
         * @param  {String} title [default = 'Confirmar']
         * @param  {String} message [default = 'Confirma tu acción ingresando tu código de empleado de 4 dígitos']
         * @return {Promise}
         */
        code: function (title, message, user = null) {
            if (user !== null && user.hasRole('MANAGER_WO_CODE')) {
                return new Promise((resolve) => {
                    resolve(
                        window._backoffice?.token_manager?.decoded_token_payload
                            ?.tfa_code || '0000',
                    );
                });
            }
            var options = {
                title: title || 'Confirmar',
                text:
                    message ||
                    'Confirma tu acción ingresando tu código de empleado de 4 dígitos',
                type: 'code',
            };

            return modal.open(options);
        },

        verifyCode: function (title, message, user = null) {
            let user_code;
            return alerts
                .code(title, message, user)
                .then((code) => {
                    user_code = code;
                    return window._backoffice.validateCode(code);
                })
                .then(({ valid: is_valid_code, new_access_token }) => {
                    if (!is_valid_code) {
                        throw new InvalidTfaCode();
                    }
                    if (new_access_token) {
                        var user_info = window._backoffice
                            .apiWithAccessToken(new_access_token)
                            .token_manager.getUserFromAccessToken();
                    }
                    return { code: user_code, user_info, new_access_token };
                });
        },
        /**
         * Asks user for ok cancel confirmation
         * @method confirm
         * @param  {strin} title
         * @param  {string} message
         * @return {Promise}
         */
        confirm: function (title, message) {
            var options = {
                title: title || 'Confirmar',
                text:
                    message || '¿Estás seguro que deseas realizar esa acción?',
                type: 'confirm',
                buttons: {
                    ok: {
                        html: 'OK',
                        class: 'btn-success btn-lg',
                    },
                    cancel: {
                        html: 'Cancelar',
                        class: 'btn-default btn-lg',
                    },
                },
            };

            return modal.open(options);
        },
        errorHandler: ErrorHandler,
    };

    return alerts;
}

export default AlertFactory;
